package org.example.zone360.models

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class GetSingleCoachResponse(
    val data: GetSingleCoachData,
)
@Serializable
data class GetSingleCoachData(
    val id: String = "",
    val rev: String  = "",
    val count: Int = 0,
    val dob: String = "",
    val email: String = "",
    val emotions: Emotions = Emotions(),
    val donut: DonutData = DonutData(),
    val fcmToken: String = "",
    val firstName: String = "",
    val imageUrl: String = "",
    val isVerified: String = "",
    val job: String = "",
    @Serializable(with = TeamsObjectSerializer::class)
    val teams: List<TeamsObject>? = emptyList(),
    val lastName: String = "",
    val level: String = "",
    val nationality: String = "",
    val organization: String = "",
    val recordTime: Int = 0,
    val role: String = "",
    val speakingTime: Double = 0.0,
    val totalKeywords: Int = 0,
    val type: String  = "",
    val payment: Payment = Payment(),
    val uid: String  = "",
    val verificationCode: String = "",
    val botQuestionAsked : Int = 0,
    val disabled: Boolean = false
)
@Serializable
data class Emotions(
    val anger: Double = 0.0,
    val disgust: Double = 0.0,
    val fear: Double = 0.0,
    val joy: Double = 0.0,
    val sadness: Double = 0.0,
)
@Serializable
data class DonutData(
    val fitness: Int? = null,
    val mental: Int? = null,
    val tactical: Int? = null,
    val technical: Int? = null,
    val custom: Int? = null,
    val goalkeeper: Int? = null
)

